import { SidebarCustomComponents } from '../constants/sidebar-custom-components';

export enum SidebarView {
    MINI_CART = 'MINI_CART',
    MINI_WISH = 'MINI_WISH',
    CUSTOM = 'CUSTOM',
}

export interface SidebarCommandProps {
    view: SidebarView;
}

export interface SidebarCustomCommandProps {
    component: SidebarCustomComponents;
    initializeFunction: string;
    data: any;
    backdrop?: boolean;
}
